import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchProfileById, resetProfile, setProfileEditionMode, resetProfileEditionMode } from 'redux/profiles/ProfilesActions';
import ManageImportProfilePage from './ManageImportProfilePage';

const mapStateToProps = ({ profiles }) => ({
  fetchingProfile: profiles.fetchingProfile
});

const mapDispatchToProps = dispatch => ({
  profileActions: bindActionCreators({ fetchProfileById, resetProfile, setProfileEditionMode, resetProfileEditionMode }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageImportProfilePage);



// WEBPACK FOOTER //
// ./src/components/importProfile/ManageImportProfilePageConnector.js